export const SEASONAL_FACTOR_WINTER = 1.25
export const SEASONAL_FACTOR_SUMMER = 0.75
export const SUMMER_MONTHS = [4, 5, 6, 7, 8, 9]
export const WINTER_MONTHS = [1, 2, 3, 10, 11, 12]

export const CARD_PAYMENT_MIN_AMOUNT_IN_POUNDS = 1
export const CARD_PAYMENT_MAX_AMOUNT_IN_POUNDS = 5000

export const REFUND_MIN_AMOUNT_IN_POUNDS = 0.01
export const REFUND_ELIGIBILITY_MAX_BILL_AGE = 93 // days
export const REFUND_MAX_BILL_AGE = 63 // days
export const REFUND_MIN_READING_AGE = 32 // days
export const REFUND_MAX_READING_AGE = 60 // days
export const REFUND_DOUBLE_PAYMENT_MONTHS = [1, 2, 9, 10, 11, 12]
export const REFUND_AMOUNT_REQUIRES_PHOTO = 500
export const COOLING_OFF_PERIOD = 14
export const PAYMENT_AMOUNT_TOLERANCE = 10

export const DEFAULT_RENEWAL_WINDOW_PERIOD = 49
export const EXIT_FEE_NO_VALUE = 0

export const ChangePaymentChoice = {
  Circumstance: "circumstance",
  FinancialDifficulty: "financialDifficulty",
  CustomerRecalculate: "CustomerRecalculate",
}

export const FinancialsTabs = {
  Overview: 0,
  Transactions: 1,
}

export const REDUCED_VAT_RATE = 1.05

// Matches the gateway's maxLength on CreateRefundApprovalRequest.description.
export const REFUND_REFERENCE_MAX_LENGTH = 255
